import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseCodeitemEditorComponent } from '../codeitem-base/codeitem-base.component';
import { CodeItemService } from './../../common/services/codeitem.service';

@Component({
  selector: 'prg-codeitem-condition',
  templateUrl: './codeitem-condition.component.html',
  styleUrls: ['./codeitem-condition.component.css']
})
export class CodeitemConditionComponent extends BaseCodeitemEditorComponent implements OnInit {

  constructor(
    store: Store<any>,
    router: Router,
    route: ActivatedRoute,
    codeitemService: CodeItemService) {
    super(store, router, route, codeitemService);


    store.select(s => s.advancedProgramming.device).subscribe(
      device => {
        if (device) {
          router.navigate(['../condition'], { relativeTo: route });
        }
      });
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/codeitem-condition/codeitem-condition.component.ts